export default __webpack_public_path__ + "static/media/Rimante_Pomeckyte_resume.92d39397.pdf";